import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=2eb8b1fc&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=2eb8b1fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb8b1fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eb8b1fc')) {
      api.createRecord('2eb8b1fc', component.options)
    } else {
      api.reload('2eb8b1fc', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=2eb8b1fc&scoped=true&", function () {
      api.rerender('2eb8b1fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rxIEZcSWfUCV/JS/comp/SearchFilterTokens.vue"
export default component.exports